import { render, staticRenderFns } from "./ModalNewCategory.vue?vue&type=template&id=27681a90&scoped=true"
import script from "./ModalNewCategory.vue?vue&type=script&lang=js"
export * from "./ModalNewCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27681a90",
  null
  
)

export default component.exports